import {
  extractAndCreateListingApiExploreGroupsGroupIdListingsExtractPost,
  extractAndUpdateListingApiExploreListingsListingIdExtractPost,
  getListingApiExploreListingsListingIdGet,
  getListingsApiExploreGroupsGroupIdListingsGet,
} from '@/client';
import type { ListingExtractRequest, PropertyListingResponse } from '@/client/types.gen';
import { createApiError } from '@/lib/api-error';
import { httpClient } from '@/lib/http-client';

export const listingKeys = {
  all: (groupId: string) => ['explore', 'group', groupId, 'listings'] as const,
  detail: (listingId: string) => ['explore', 'listing', listingId] as const,
};

function unwrap<T>(response: { data?: unknown; error?: unknown }): T {
  if (response.error) throw createApiError(response.error);
  return response.data as T;
}

export async function getListings(groupId: string): Promise<PropertyListingResponse[]> {
  return unwrap(await getListingsApiExploreGroupsGroupIdListingsGet({
    client: httpClient,
    path: { group_id: groupId },
    headers: { authorization: '' },
    throwOnError: false,
  }));
}

export async function getListing(listingId: string): Promise<PropertyListingResponse> {
  return unwrap(await getListingApiExploreListingsListingIdGet({
    client: httpClient,
    path: { listing_id: listingId },
    headers: { authorization: '' },
    throwOnError: false,
  }));
}

export async function enrichListing(
  listingId: string,
  payload: ListingExtractRequest,
): Promise<PropertyListingResponse> {
  return unwrap(await extractAndUpdateListingApiExploreListingsListingIdExtractPost({
    client: httpClient,
    path: { listing_id: listingId },
    body: payload,
    headers: { authorization: '' },
    throwOnError: false,
  }));
}

export async function extractAndCreateListing(
  groupId: string,
  payload: ListingExtractRequest,
): Promise<PropertyListingResponse> {
  return unwrap(await extractAndCreateListingApiExploreGroupsGroupIdListingsExtractPost({
    client: httpClient,
    path: { group_id: groupId },
    body: payload,
    headers: { authorization: '' },
    throwOnError: false,
  }));
}
